import { ProgressBar, Skeleton } from '@welbe/web-design-system';
import React, { useEffect, useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { getPercentage } from '../../services/collaborators';
import {
	CollaboratorsAttencion,
	CollaboratorsPercentage,
	CollaboratorText,
	ReferButton,
} from './CollaboratorsPercentual.styles';

interface ICollaboratorsPercentual {
	questionnaireId: string;
	campaignId: string;
	sequence: number | undefined;
	onRefer: (type: string, amount: number) => void;
}

interface IRequireAttention {
	percentage: number;
	requireAttention: number;
	totalEmployees: number;
}

export const CollaboratorsPercentual = ({
	questionnaireId,
	campaignId,
	sequence,
	onRefer,
}: ICollaboratorsPercentual): JSX.Element => {
	const [isLoading, setLoading] = useState<boolean>(true);
	const [requiredAttention, setRequiredAttention] = useState<IRequireAttention>(
		{
			percentage: 0,
			requireAttention: 0,
			totalEmployees: 0,
		},
	);

	const fetchPercentage = async () => {
		try {
			setLoading(true);
			const { data } = await getPercentage(campaignId, questionnaireId);
			setRequiredAttention({ ...data.content });
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'collaboratorsPercentual',
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (questionnaireId) {
			fetchPercentage();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionnaireId]);

	return (
		<CollaboratorsPercentage>
			{isLoading ? (
				<>
					<Skeleton width="94px" height="94px" />
					<CollaboratorsAttencion variant={isLoading}>
						<Skeleton width="232px" height="44px" />
						<Skeleton width="150px" height="22px" />
					</CollaboratorsAttencion>
				</>
			) : (
				<>
					<ProgressBar
						hasLabel
						isDonut
						percentValue={requiredAttention.percentage}
						donutSize="90px"
						backgroundColor="#D8DEE6"
						labelColor="#64778F"
						progressColor="#C22A58"
					/>
					<CollaboratorsAttencion>
						<CollaboratorText>
							Total de colaboradores que requieren atención{' '}
							<span>{requiredAttention.requireAttention}</span>
						</CollaboratorText>
						{sequence === 0 && requiredAttention.requireAttention > 0 && (
							<ReferButton
								onClick={() =>
									onRefer('all', requiredAttention.requireAttention)
								}
							>
								Referir a todos
							</ReferButton>
						)}
					</CollaboratorsAttencion>
				</>
			)}
		</CollaboratorsPercentage>
	);
};
